import Base64 from '@/utils/base64'
import {
  mainCoinsHolders,
  conbineHolderList,
  btyHolderRank,
  btyHolderNum
} from '../../config/apiServe/new-rpc.js'
import {
  filterAdrTag
} from "@/utils/filters.js";
export default {
  data() {
    return {
      type: 'personage',
      loading:true,
      maxHash: '',
      maxHeight: 0,
      holderInfo: {
        symbol: process.env.VUE_APP_BASECOIN
      },
      HolderList: [],
      listParam: [{
        match: [{
            "value": "coins",
            "key": "asset_exec"
          },
          {
            "value": "16htvcBNSEA7fZhAdLJphDwQRQJaHpyHTp",
            "key": "exec"
          }
        ],
        match_one: [{
          key: 'type',
          value: 'contractInternal'
        }],
        sort: [{
          "key": "frozen",
          "ascending": false
        }],
        range: [{
          key: 'frozen',
          gt: 0
        }],
        page: {
          "size": 10,
          "number": 1
        }
      }],
      btyParam: [{
        "page": {
          "number": 1,
          "size": 10
        }
      }],
      pages: {
        number: 1,
        size: 10
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getCoinsHolders()
      await this.getLastBlock()
    },
    async selectType(type) {
      console.log(type, 11)
      this.pages = {
        number: 1,
        size: 10
      }
      this.type = type
      if (type === 'miner') {
        this.getHolderList(this.pages)
        this.getCoinsHolders()
      } else {
        this.getBtyHolders(this.pages)
        this.getBtyCount()
      }
    },
    // 获取持币量总人数
    async getBtyCount() {
      const res = await btyHolderNum()
      this.holderInfo.holders = res.result || 0
    },
    // 获取BTY持有列表
    async getBtyHolders(pages) {
      this.btyParam[0].page = pages
      this.loading = true
      let list = await btyHolderRank(this.btyParam)
      this.loading = false
      if (list.error === null) {
        let total = this.holderInfo.total
        this.HolderList = list.result
        this.HolderList.forEach((item, index) => {
          item.rank = index + (this.pages.number - 1) * this.pages.size + 1
          item.percent = (item.total / (total * 1000000)).toFixed(2)
        })
      }
    },
    // 获取持有人总数
    getCoinsHolders() {
      mainCoinsHolders(this.listParam).then(res => {
        if (res.error === null) this.holderInfo.holders = res.result
      })
    },
    // 获取最新区块
    getLastBlock() {
      this.Rpc.getLastHeader().then((data) => {
        if (data.error === null) {
          this.maxHash = data.result.hash
          this.maxHeight = data.result.height
          this.hexCharCodeToStr(this.maxHash)
        }
      })
    },
    //获取BTY总量
    getBTYtradeSum(hash) {
      this.Rpc.queryTotalFee([`${hash}`]).then(data => {
        if (data.error === null) {
          // 2270000分叉区块，收益30 --> 8
          this.holderInfo.total =
            this.maxHeight > 2269999 ?
            367369978 + 8 * this.maxHeight - data.result.fee / 100000000 :
            317430000 + 30 * this.maxHeight - data.result.fee / 100000000;
          this.holderInfo = JSON.parse(JSON.stringify(this.holderInfo))
          this.selectType(this.type)
        } else {
          this.$notify({
            title: this.$t('components.tip'),
            message: data.error,
            type: "warning"
          });
        }
      })
    },
    // 16进制转换处理
    hexCharCodeToStr(hexCharCodeStr) {
      let num = hexCharCodeStr;
      let trimedStr = num.trim();
      let rawStr =
        trimedStr.substr(0, 2).toLowerCase() === "0x" ?
        trimedStr.substr(2) :
        trimedStr;
      let len = rawStr.length;
      if (len % 2 !== 0) {
        alert("Illegal Format ASCII Code!");
        return "";
      }
      let curCharCode;
      let resultStr = [];
      for (let i = 0; i < len; i = i + 2) {
        curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
        resultStr.push(String.fromCharCode(curCharCode));
      }
      //转码ASCII——base64
      let b = new Base64();
      let str = b.encode(`TotalFeeKey:${resultStr.join("")}`);
      this.getBTYtradeSum(str)
    },
    // 获取持有人列表
    async getHolderList(pages) {
      this.listParam[0].page = pages
      let list = await conbineHolderList(this.listParam)
      if (list.error === null) {
        let total = this.holderInfo.total
        this.HolderList = list.result
        this.HolderList.forEach((item, index) => {
          item.rank = index + (this.pages.number - 1) * this.pages.size + 1
          item.percent = (item.frozen / (total * 1000000)).toFixed(2)
        })
      }
    },
    isContact(adr) {
      return filterAdrTag(adr);
    },
    pageChange(page) {
      this.pages.number = page;
      this.type === 'miner' ? this.getHolderList(this.pages) : this.getBtyHolders(this.pages)
    },
    sizeChange(size) {
      this.pages.size = size;
      this.pages.number = 1;
      this.type === 'miner' ? this.getHolderList(this.pages) : this.getBtyHolders(this.pages)
    }
  }
}